<template>
  <div class="px-4 pb-4 text-center">
    <student-form :child="child" :alert="alert"/>
    <b-button @click="editChild()" class="btn-neue" variant="none">
      <clip-loader :loading="processing" :color="'white'" :size="'17px'"></clip-loader>
      <span v-if="!processing">Fertig</span>
    </b-button>
  </div>
</template>

<script>
import childwebApi from '@/api/v1/childweb';
import StudentForm from '@/components/Student/Form';
import alert from '@/mixins/alert';

export default {
  mixins: [alert],
  components: { StudentForm },
  props: ['student'],
  data() {
    return {
      processing: false,
      child: Object.assign({}, this.student),
    };
  },
  methods: {
    editChild() {
      const vm = this;
      vm.clearAlerts();

      if(!vm.child.firstname || !vm.child.lastname){
          vm.alert.error = "Bitte geben Sie Vorname und Nachname des Schülers/der Schülerin an.";
      }
      else if(vm.child.firstname.length > 25 || vm.child.lastname.length > 25){
          vm.alert.error = "Ihre Eingabe ist zu lang!";
      }
      else if(!this.validWhiteSpace(vm.child.firstname) || !this.validWhiteSpace(vm.child.lastname)) {
        return vm.alert.error = 'Der erste Buchstabe darf kein Leerzeichen sein!';
      }
      else {
        vm.processing = true;

        childwebApi.edit(this.child).then(() => {
          vm.processing = false;
          vm.student.firstname = this.convertEmoji(this.child.firstname);
          vm.student.lastname = this.convertEmoji(this.child.lastname);
          vm.$emit('edit:student', this.student);
          vm.clearAlerts();
        }).catch(() => {
          vm.processing = false;
          vm.alert.error = 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.';
        });
      }
    },
    clearData(){
      this.alert.error = "";
    },
    validWhiteSpace: function (name) {
      var re = /^\S/;
      return re.test(name);
    },
    convertEmoji(string) {
      var formatedString = '';

      for (var i = 0; i < string.length; i++) {

        if(this.emojiCheck(string[i])){
          formatedString += this.toUTF16((string[i]).codePointAt(0));
        }
        else if(this.emojiCheck(string[i] + string[i + 1]) && i < string.length) {
          formatedString += this.toUTF16((string[i] + string[i + 1]).codePointAt(0));
          i++;
        }
        else{
          formatedString += string[i];
        }
      }
      return formatedString;
    },
    toUTF16(codePoint) {
      var TEN_BITS = parseInt('1111111111', 2);
      function u(codeUnit) {
        return '\\u'+codeUnit.toString(16).toUpperCase();
      }

      if (codePoint <= 0xFFFF) {
        return u(codePoint);
      }
      codePoint -= 0x10000;

      // Shift right to get to most significant 10 bits
      var leadSurrogate = 0xD800 + (codePoint >> 10);

      // Mask to get least significant 10 bits
      var tailSurrogate = 0xDC00 + (codePoint & TEN_BITS);

      return u(leadSurrogate) + u(tailSurrogate);
    },
    emojiCheck(string) {
      const test = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/.test(string);
      return test;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Student/Edit.vue